import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import ProductDetail from '../pages/ProductDetail.vue'
import Recrutment from '../pages/Recrutment.vue'
import AllProductByCat from '../pages/AllProductByCat.vue'
import AllProduct from '../pages/AllProduct.vue'
import Auth from '../pages/Auth.vue'
import Project from '../pages/Project.vue'
import About from '../pages/AboutP.vue'
import Services from '../pages/ServicesP.vue'
import FeedbackP from '../pages/FeedbackP.vue'
import ContactP from '../pages/ContactP.vue'
import PartenaireDetails from '../pages/PartenaireDetails.vue'

const routes = [
  {path :'/', component: Home},
  { path: '/detailproduct/:id', component: ProductDetail, props: true },
  {path :'/Recrutment', component: Recrutment},
  { path: '/ByCat/:id', component: AllProductByCat, props: true },
  { path: '/Project', component: Project},
  { path: '/Feedback', component: FeedbackP},
  { path: '/ContactP', component: ContactP},
  { path: '/Services', component: Services},
  { path: '/Auth', component: Auth},
  { path: '/About', component: About},
  { path: '/allProduct', component: AllProduct},
  { path: '/PDetails/::slug', component: PartenaireDetails},

]




const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router